import { useMediaQuery } from '@mui/material';

/** Width below which the desktop navbar bar no longer fits. */
export const NAVBAR_COLLAPSE_WIDTH_PX = 1500;

/** Below `NAVBAR_COLLAPSE_WIDTH_PX` the navbar collapses into a hamburger + drawer. */
export const useIsNavbarCollapsed = (): boolean =>
  useMediaQuery(`(max-width:${NAVBAR_COLLAPSE_WIDTH_PX - 0.05}px)`);